/* global Vue */
import ContactFormComponent from './contact-form.vue';
import PromotionFormComponent from './promotion-form.vue';
import RealtorVipFormComponent from './realtor-vip-form.vue';
import InterestListFormComponent from './interest-list-form.vue';
import CommunityContactFormComponent from './community-contact-form.vue';
import ServiceRequestFormComponent from './service-request-form.vue';
import SalesOfficeFormComponent from './sales-office-form.vue';

Vue.component('contact-form', ContactFormComponent);
Vue.component('promotion-form', PromotionFormComponent);
Vue.component('realtor-vip-form', RealtorVipFormComponent);
Vue.component('interest-list-form', InterestListFormComponent);
Vue.component('community-contact-form', CommunityContactFormComponent);
Vue.component('service-request-form', ServiceRequestFormComponent);
Vue.component('sales-office-form', SalesOfficeFormComponent);